<template>
  <div class="alert-message-area">
    <div v-html="props.message"
         style="line-height: 18px;"></div>
    <div class="mgt10">
      <button v-for="({nm, color, value}, index) in btns"
              class="ssmall"
              :class="'bt-' + color"
              :key="'btn_'+index"
              ref="btnRefs"
              @click="btn_click(value)">
        {{ nm }}
      </button>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, reactive, defineEmits, nextTick} from 'vue';
import {hide} from "@/utils/confirm";

const props = defineProps({
  message: {
    type: String,
    required: true
  },
  confirmNm: {
    default: '확인',
    type: String,
    required: false
  },
  cancelNm: {
    default: '취소',
    type: String,
    required: false
  },
});

const btnRefs = ref([]);
const btns = reactive([
  {
    nm: props.cancelNm,
    value: false,
    color: 'white',
  },
  {
    nm: props.confirmNm,
    value: true,
    color: 'purple',
  },
]);

const emits = defineEmits(['close']);
const btn_click = (value) => {
  hide(value);
  emits('close');
}

onMounted( async () => {
  await nextTick(() => {
    // cancelNm 버튼에 focus
    btnRefs.value[0].focus();
  })
})

</script>

<style scoped>
.alert-message-area {
  text-align: center;
  min-width: 200px;
  overflow: hidden;
  word-break: break-all;
  font-size: 14px;
}
</style>